import React from 'react';

// Components
import MaintainerListItem from './MaintainerListItem';

const MaintainerList = ({ maintainers }) => (
  <ul>
    { maintainers.map((maintainer, index) => <MaintainerListItem key={index} {...maintainer} />) }
  </ul>
)

export default MaintainerList



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/MaintainerList.js